import React from 'react';
import { TransmissionDiagram } from './TransmissionDiagram';
import { DeliveryDiagram } from './DeliveryDiagram';
import { ProphylaxisDiagram, PCRTimeline } from './NeonatalDiagrams';
import { GeneratedClinicalVisual } from './GeneratedClinicalVisual';

const renderers = {
  'mecanismos_tmi_etapas.png': TransmissionDiagram,
  'algoritmo_via_parto_cv.png': DeliveryDiagram,
  'esquemas_profilaxis_neonatal.png': ProphylaxisDiagram,
  'calendario_pcr_pediatrico.png': PCRTimeline,
};

export const ClinicalAssetRenderer = ({ nombre_asset_visual, pie_de_figura, visual, tipo_asset, testId = 'clinical-asset' }) => {
  if (!nombre_asset_visual || nombre_asset_visual.trim().toLowerCase() === 'ninguno' || tipo_asset?.trim().toLowerCase() === 'ninguno') return null;
  const Diagram = renderers[nombre_asset_visual];
  const caption = pie_de_figura && pie_de_figura.toLowerCase() !== 'ninguno' ? pie_de_figura : '';
  return (
    <figure data-testid={testId} data-asset-name={nombre_asset_visual} className="mc-diagram mb-8 border-y border-neutral-200 py-6">
      <p className="mb-5 text-xs font-bold uppercase text-neutral-500" data-testid={`${testId}-label`}>Esquema clínico</p>
      {Diagram ? <Diagram /> : visual?.data ? <GeneratedClinicalVisual data={visual.data} /> : <p data-testid={`${testId}-status`} role="status">{['queued', 'generating'].includes(visual?.status) ? 'Apoyo visual en preparación…' : 'Apoyo visual pendiente de generación o revisión.'}</p>}
      {(Diagram || visual?.data) && caption && <figcaption data-testid={`${testId}-caption`} className="mt-4 text-xs text-neutral-600">{caption}</figcaption>}
    </figure>
  );
};